// extracted by mini-css-extract-plugin
export default {"icon":"IconSidebar_icon__tc7mi","photo":"IconSidebar_photo__Ok9UH"};